import { render } from "./HangMan.vue?vue&type=template&id=24641e9a"
import script from "./HangMan.vue?vue&type=script&lang=ts"
export * from "./HangMan.vue?vue&type=script&lang=ts"
script.render = render

export default script